import { useQuery } from "react-query";
import { JobHttpService } from "../service";

const UseJobDetail = (jobId, options = {}) => {
    return useQuery(
        ["job_detail", jobId],
        () => JobHttpService.loadJob(jobId),
        {
            enabled: Boolean(jobId),
            ...options
        }
    );
};

export default UseJobDetail;

